import {
    GET_TARIFF_RATES,
    GET_TARIFF_RATES_BY_HEAD,
    GET_TARIFF_RATE_DETAILS,
    CREATE_TARIFF_RATE,
    UPDATE_TARIFF_RATE,
    UPDATE_TARIFF_RATE_STATUS,
    DELETE_TARIFF_RATE
} from '../../index.types';

// Get All Tariff Rates
export const getTariffRates = (data) => ({
    type: GET_TARIFF_RATES,
    data
});

// Get Tariff Rates By Head
export const getTariffRatesByHead = (data) => ({
    type: GET_TARIFF_RATES_BY_HEAD,
    data
});

// Get Tariff Rate Details
export const getTariffRateDetails = (data) => ({
    type: GET_TARIFF_RATE_DETAILS,
    data
});

// Create Tariff Rate
export const createTariffRate = (data) => ({
    type: CREATE_TARIFF_RATE,
    data
});

// Update Tariff Rate
export const updateTariffRate = (data) => ({
    type: UPDATE_TARIFF_RATE,
    data
});

// Update Tariff Rate Status (Activate/Deactivate)
export const updateTariffRateStatus = (data) => ({
    type: UPDATE_TARIFF_RATE_STATUS,
    data
});

// Delete Tariff Rate
export const deleteTariffRate = (data) => ({
    type: DELETE_TARIFF_RATE,
    data
});
